<div class="row">
  <div class="col-xl-12">
    <h3>{{'AnnaPerenna' |translate}}</h3>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <span class="fa-light fa-rotate fa-lg float-right cursorPointer" (click)="resetMonitors()"></span>
  </div>
</div>
@for (monitor of monitors; track monitor; let i = $index) {
  @if (i % 6 === 0) {
    <div class="row mb-4">
      @if (monitors[i]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
      @if (monitors[i+1]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i+1]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
      @if (monitors[i+2]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i+2]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
      @if (monitors[i+3]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i+3]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
      @if (monitors[i+4]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i+4]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
      @if (monitors[i+5]) {
        <div class="col-xl-2">
          <ap-monitor-card (monitorInEdit)="monitorInEdit($event)" (monitorRemovedEmit)="monitorRemovedEmit($event)"
          [monitor]="monitors[i+5]" [profiles]="profiles"></ap-monitor-card>
        </div>
      }
    </div>
  }
  @if (monitorsNotFound) {
    <div>
      {{'NO_DEVICES' |translate}}
    </div>
  }
}

<div class="row">
  <div class="col-lg-12">
    @if (!monitors && !monitorsNotFound) {
      <div>
        <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg" />
      </div>
    }
  </div>
</div>
